import React from 'react';
import { Box, Typography } from '@mui/material';

const Disclaimer = () => {
  return (
    <Box sx={{ px: { xs: 2, sm: 4, md: 6 }, pb: 4, bgcolor: 'background.default' }}>
      <Typography
        variant="body2"
        align="center"
        sx={{
          maxWidth: '800px',
          mx: 'auto',
          px: { xs: 2, sm: 3 },
          lineHeight: 1.7,
          color: 'text.secondary',
        }}
      >
        fideprep.ch is an independent educational platform. We are not affiliated with, endorsed by, or connected to the
        official fide secretariat or the Swiss State Secretariat for Migration (SEM). "fide" is a registered trademark
        of its respective owners.
      </Typography>
    </Box>
  );
};

export default Disclaimer;
